import { Button, Card } from 'semantic-ui-react';
import styled from 'styled-components'

interface Props {
  $pdfType: boolean;
  $width?: string;
}

export const StyledCard = styled(Card)`
position: relative;
  &&& {
    box-shadow: none;
    border: none;
    border-radius: 0;
    background-color: #f5f5f5;
  }
  .title {
    text-align: center;
    font-size: 16px !important;
    margin: 20px 0px;
    font-weight: bold;
  }
`;

export const StyledCarousel = styled.div<{ $videoType: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => !props.$videoType ? 'height: 500px;' : ''}  
  overflow: hidden;
`;

export const StyledCarouselSlide = styled.div<Props>`
  display: flex;
  width: 200%;
  ${props => props.$pdfType ? 'height: 100%;' : ''}
`;

export const StyledCarouselItem = styled.div<Props>`
  flex-shrink: 0;
  width: ${props => props.$pdfType ? '100%' : props.$width};
  position: relative;
  ${props => props.$pdfType ? 'height: 100%;' : ''}
  margin: auto;
  img video {
    max-width: 100%;
    height: auto;
    display: block;
  }
`;

export const TitleWrapper = styled.div`
right: 10px;
width: auto !important;
margin-top: 15px;
top: 10px;
display: flex;
align-items: center;
justify-content: end;
gap: 30px;
padding: 0px 20px;
`

export const StyledButtonLeft = styled(Button)`
  &&& {
    position: absolute;
    top: 50%;
    height: 100%;
    left: -40px;
    transform: translateY(-50%);
    background-color: transparent !important;
    color: #000 !important;
    border-radius: 0;
    padding: 0;
    margin: 0;
    font-size: 2rem !important;
    &:hover {
      background-color: white !important;
      color: #000;
      opacity: 0.7;
    }
  }
`;

export const StyledButtonRight = styled(Button)`
  &&& {
    position: absolute;
    top: 50%;
    height: 100%;
    right: -40px;
    transform: translateY(-50%);
    background-color: transparent !important;
    color: #000;
    border-radius: 0;
    padding: 0;
    margin: 0;
    font-size: 2rem !important;
    &:hover {
      background-color: white !important;
      color: #000;
      opacity: 0.7;
    }
  }
`;

export const InformationWrapper = styled.div`
 div {
  background: white;
 margin: 10px;
 border-radius: 10px;
 padding: 15px; 
 }
  .left {
    margin-left: 21px;
  }
    `

export const StyledRefreshButton = styled(Button)`
position: absolute;
right: 10px;
width: auto !important;
top: 10px;
`
export const StyledDownloadButton = styled(Button) <{ pdfAlignRight: boolean }>`
position: absolute;
right: ${props => props.pdfAlignRight ? '130px' : '10px'};
width: auto !important;
top: 10px;
`
export const StyledTextOnlyWrapper = styled.div`
  .right-arrow {
    margin-right: 20px !important;
  }
  .left-arrow {
    margin-left: 20px !important;
  }
`